/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hood_Db_TitleInputs */

const en_hood_db_title = /** @type {(inputs: Hood_Db_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One database, walls inside`)
};

/**
* | output |
* | --- |
* | "One database, walls inside" |
*
* @param {Hood_Db_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hood_db_title = /** @type {((inputs?: Hood_Db_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hood_Db_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hood_db_title(inputs)
});